// extracted by mini-css-extract-plugin
export default {"file":"file_file__l2XXN"};